/* PDP card video: the <pdp-card-video> custom element. Loaded with `defer` from layout/theme.liquid on templates where a
   product page or a quick-add / product card can appear. Defined once and guarded: markup inserted later from fetched HTML
   (quick-add modal, variant switching) never runs its own scripts, but upgrades as soon as this file has defined the element. */
(function () {
  if (!window.customElements || customElements.get('pdp-card-video')) return;
  customElements.define('pdp-card-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.btn = this.querySelector('.pcv-btn');
      if (!this.video) return;
      /* Everything is bound through one AbortController so a disconnect/re-connect never doubles the handlers. */
      this._ac = new AbortController();
      var signal = this._ac.signal, self = this, sx = 0, sy = 0;
      this.video.addEventListener('playing', function () { self.classList.add('pcv-on'); self._label(true); }, { signal: signal });
      this.video.addEventListener('pause', function () { self.classList.remove('pcv-on'); self._label(false); }, { signal: signal });
      if (this.btn) {
        this.btn.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; }, { signal: signal });
        /* A real <button>: Enter/Space fire click too (keyboard clicks report 0,0, so only pointer drags are filtered). */
        this.btn.addEventListener('click', function (e) {
          if (e.detail > 0 && (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10)) return;
          if (self.video.paused) { self.userPaused = false; self.play(); } else { self.userPaused = true; self.video.pause(); }
        }, { signal: signal });
      }
      /* The observer always exists (it pauses the clip when it scrolls out of view, also after a manual tap); reduced motion /
         Save-Data only skip the AUTOplay. */
      this._calm = (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) ||
        (navigator.connection && navigator.connection.saveData);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.5) { if (!self._calm && !self.userPaused) self.whenIdle(); }
            else { self.wantPlay = false; if (!self.video.paused) self.video.pause(); }
          });
        }, { threshold: [0, 0.5, 1] });
        this.io.observe(this);
      }
    }
    disconnectedCallback() {
      if (this._ac) this._ac.abort();
      if (this.io) this.io.disconnect();
      this.wantPlay = false; this._armed = false;
    }
    _label(playing) {
      if (!this.btn) return;
      this.btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      this.btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }
    /* Arms ONE deferred autoplay per in-view episode: wait for the poster (the LCP image), then idle, then play. Repeated
       threshold crossings only flip wantPlay, they never stack listeners or callbacks. */
    whenIdle() {
      this.wantPlay = true;
      if (this._armed) return;
      this._armed = true;
      var self = this, img = this.querySelector('.pcv-poster'), signal = this._ac && this._ac.signal;
      var go = function () { self._armed = false; if (self.wantPlay && self.isConnected) self.play(); };
      var after = function () { if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 800 }); else setTimeout(go, 200); };
      /* Gate on the poster, not on window.onload: Rocket Loader can hold load handlers back for seconds. */
      if (!img || img.complete) after();
      else { var o = { once: true, signal: signal }; img.addEventListener('load', after, o); img.addEventListener('error', after, o); }
    }
    play() {
      if (!this.isConnected) return;
      var v = this.video;
      if (!v.getAttribute('src')) v.setAttribute('src', this.dataset.src);
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
  });
})();
